import { handleErrorByStatus } from "../errorHandler";

export async function downloadFile(
  filename: string,
  url: string,
  onSuccess: Function,
  onFailure: Function
) {
  const file = await fetch(url);
  if (file.status < 200 || file.status > 299) {
    handleErrorByStatus(file.status, onFailure);
  } else {
    const fileBlob = await file.blob();
    const fileUrl = URL.createObjectURL(fileBlob);

    const anchor = document.createElement("a");
    anchor.href = fileUrl;
    anchor.download = filename;

    document.body.appendChild(anchor);
    anchor.click();
    document.body.removeChild(anchor);
    URL.revokeObjectURL(fileUrl);
    onSuccess();
  }
}
